<template>
  <div>
    <div class="col-md-12 mb-5" style="padding-right: 0">
      <b-form>
        <div class="row">
          <b-input
            placeholder="Tìm kiếm theo tên"
            v-model="search"
            append-icon="search"
            single-line
            hide-details
            class="col-md-4 btn-sm"
            @keyup="debounceSearchPermission"
            v-on:keyup.enter="debounceSearchPermission"
          ></b-input>
        </div>
      </b-form>
    </div>

    <div class="row">
      <div class="col-md-6">
        <h5 class="mb-3">Danh sách quyền</h5>
        <b-table
          :items="listItem"
          :fields="fields"
          class="table-bordered table-hover"
          :busy="onLoading"
          @row-clicked="selectPermission"
          :tbody-tr-class="getRowClass"
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="4"></vcl-table>
          </template>
          <template v-slot:cell(count)="row">
            <div>
              <span v-text="row.item.count" class="d-flex justify-content-center"></span>
            </div>
          </template>
          <template v-slot:cell(code)="row">
            <div class="cursor-pointer">
              <span v-text="row.item.code"></span>
            </div>
          </template>
          <template v-slot:cell(name)="row">
            <div class="font-weight-bolder cursor-pointer">
              <span v-text="row.item.name"></span>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="d-flex justify-content-center">
              <b-dropdown size="sm" id="dropdown-left" no-caret right>
                <template slot="button-content">
                  <i style="font-size: 1rem; padding-right: 0px" class="flaticon2-settings"></i>
                </template>
                <b-dropdown-item @click.stop="editItem(row.item)" v-if="checkViewOnly()">
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 10px" class="flaticon2-box-1"></i>
                    &nbsp; Chi tiết
                  </span>
                </b-dropdown-item>
                <b-dropdown-item @click.stop="editItem(row.item)" v-if="!checkViewOnly()">
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem" class="flaticon2-pen"></i>
                    &nbsp; Chỉnh sửa
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  @click.stop="showDeleteAlert(row.item)"
                  v-if="checkPermission(listPermission, 'ROLE_DELETE')"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 1rem; color: #d33" class="flaticon2-rubbish-bin-delete-button"></i>
                    &nbsp; Xóa
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>

        <b-row>
          <b-col>
            <p class="text-dark" style="font-weight: 500">Tổng số: {{ totalItems }}</p>
          </b-col>
          <b-col>
            <BPaginationNavCustom
              :number-of-pages="totalPages || 1"
              :current-page="page"
              :total-page="totalPages || 1"
              @page-change="handlePageChange"
            />
          </b-col>
        </b-row>
      </div>

      <div class="col-md-6">
        <h5 class="mb-3">
          Các thành viên:
          <span class="text-primary">{{ selectedPermission && selectedPermission.name }}</span>
        </h5>
        <div v-if="!selectedPermission" class="text-center text-muted py-5">
          <i class="flaticon2-information" style="font-size: 3rem; opacity: 0.3"></i>
          <p class="mt-3">Vui lòng chọn một nhóm tài khoản để xem danh sách thành viên</p>
        </div>
        <div v-else>
          <b-table
            :items="membersList"
            :fields="memberFields"
            class="table-bordered table-hover"
            :busy="membersLoading"
            small
          >
            <template v-slot:table-busy>
              <vcl-table :speed="5" :animate="true" :columns="4"></vcl-table>
            </template>
            <template v-slot:cell(count)="row">
              <div>
                <span v-text="row.index + 1" class="d-flex justify-content-center"></span>
              </div>
            </template>
            <template v-slot:cell(isActive)="row">
              <i
                v-bind:class="{
                  'fas fa-check text-success': row.item.isActive == 1,
                  'fas fa-minus-circle text-danger': row.item.isActive != 1,
                }"
              />
            </template>
          </b-table>
          <div v-if="membersList.length === 0 && !membersLoading" class="text-center text-muted py-3">
            <p>Nhóm này chưa có thành viên nào</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import Swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import { checkPermission } from '@/utils/permission';
import { VclTable } from 'vue-content-loading';
import { handleError, makeToastFaile, makeToastSuccess } from '@/utils/common';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';
import { debounce } from 'lodash';
import { TIME_TRIGGER } from '@/utils/constants';

export default {
  name: 'PermissionTab',
  components: { VclTable, BPaginationNavCustom },
  data() {
    return {
      search: '',
      fields: [
        {
          key: 'count',
          label: 'STT',
          sortable: false,
          tdClass: 'sttClass',
          thClass: 'sttClass',
          thStyle: { fontWeight: 600, color: '#181c32', textAlign: 'center' },
        },
        {
          key: 'code',
          label: 'Mã',
          sortable: false,
          tdClass: 'codeClass',
          thClass: 'codeClass',
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'name',
          label: 'Tên',
          sortable: false,
          tdClass: 'nameClass',
          thClass: 'nameClass',
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        { key: 'actions', label: '', width: '10%' },
      ],
      memberFields: [
        {
          key: 'count',
          label: 'STT',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', textAlign: 'center' },
        },
        {
          key: 'username',
          label: 'Tài khoản',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'employeeName',
          label: 'Họ và tên',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'storeName',
          label: 'Cửa hàng',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'isActive',
          label: 'Trạng thái',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
          tdClass: 'text-center',
        },
      ],
      listItem: [],
      membersList: [],
      selectedPermission: null,
      membersLoading: false,
      page: 1,
      totalPages: 0,
      totalItems: 0,
      onLoading: false,
    };
  },
  computed: {
    ...mapGetters(['listPermission']),
  },
  created() {
    this.fetchData();
  },
  methods: {
    checkPermission,
    debounceSearchPermission: debounce(function () {
      this.onFilter();
    }, TIME_TRIGGER),
    onFilter: async function () {
      this.$route.query.page = 1;
      this.$router.push({ name: 'list-permissions' });
      this.fetchData();
    },
    fetchData: async function () {
      this.onLoading = true;
      this.page = this.$route.query.page;
      if (!this.page) this.page = 1;
      const params = { page: this.page, limit: 10 };
      if (this.search) params.searchText = this.search.trim();
      ApiService.query('v1/roles', { params }).then((response) => {
        const responseData = response.data.data;
        this.totalPages = responseData.totalPage;
        this.totalItems = responseData.totalRow;
        this.listItem = responseData.dataset.map((item, index) => ({
          ...item,
          count: index + 1,
        }));
        this.onLoading = false;
      });
    },
    editItem: function (item) {
      this.$router.push({ name: 'upsert-permission', query: { id: item.id } });
    },
    deleteItem: async function (item) {
      ApiService.delete(`role/${item.id}`).then(({ data }) => {
        if (data.status === 1) {
          makeToastSuccess('Xóa quyền thành công!');
          this.fetchData();
        } else {
          makeToastFaile('Xóa quyền thất bại!');
        }
      });
    },
    showDeleteAlert: function (item) {
      Swal.fire({
        title: 'Xóa tài khoản!',
        text: 'Bạn có chắc muốn xóa tài khoản này không ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
      }).then((result) => {
        if (result.value) this.deleteItem(item);
      });
    },
    selectPermission: function (permission) {
      this.selectedPermission = permission;
      this.fetchMembers(permission.id);
    },
    fetchMembers: async function (roleId) {
      this.membersLoading = true;
      try {
        const {
          data: { data: users },
        } = await ApiService.get(`v1/roles/${roleId}/members`);
        this.membersList = users;
      } catch (error) {
        handleError(error);
      } finally {
        this.membersLoading = false;
      }
    },
    getRowClass: function (item, type) {
      if (type === 'row' && this.selectedPermission && item.id === this.selectedPermission.id) {
        return 'table-active';
      }
      return '';
    },
    handlePageChange: function (pageNum) {
      this.page = pageNum;
      this.fetchData();
    },
    checkViewOnly: function () {
      return !this.checkPermission(this.listPermission, 'ROLE_UPDATE');
    },
  },
};
</script>
